<span class="side-panel-label" style="margin-top:0.75rem">Sponsored</span>
<a class="bulenox-banner" [href]="link" target="_blank" rel="noopener noreferrer">
  <div class="bb-header">
    <span class="bb-brand">Bulenox</span>
    <span class="bb-tag">Futures</span>
  </div>
  <div class="bb-accounts">
    <div class="bb-row" *ngFor="let account of accounts">
      <span class="bb-size">{{ account.size }}</span>
      <span class="bb-sep">—</span>
      <span class="bb-contracts">{{ account.contracts }}</span>
    </div>
  </div>
  <span class="bb-offer-label">{{ optionLabel }}</span>
  <div class="bb-discount">{{ discount }}</div>
  <div class="bb-coupon">
    <span class="bb-coupon-label">Use Code</span>
    <button class="bb-coupon-code" type="button" (click)="copyCode($event)" [class.bb-coupon-code--copied]="copied">
      <span class="bb-coupon-text">{{ couponCode }}</span>
      <span class="bb-copy-icon">
        <svg *ngIf="!copied" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
        </svg>
        <svg *ngIf="copied" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"/>
        </svg>
      </span>
    </button>
    <span class="bb-copied-msg" *ngIf="copied">Copied!</span>
  </div>
  <span class="bb-expiry" *ngIf="expiry">Valid until {{ expiry }}</span>
</a>
